import React, { useRef, KeyboardEvent } from 'react';
import { Button, Input } from 'antd';
import { SendOutlined, StopOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface InputAreaProps {
  value: string;
  onChange: (val: string) => void;
  onSend: () => void;
  onStop: () => void;
  isStreaming: boolean;
  disabled: boolean;
}

const InputArea: React.FC<InputAreaProps> = ({
  value,
  onChange,
  onSend,
  onStop,
  isStreaming,
  disabled,
}) => {
  const textareaRef = useRef<any>(null);

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isStreaming && value.trim()) {
        onSend();
      }
    }
  };

  return (
    <div className="ai-chat-input-area">
      <TextArea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask a question about your IT data… (Shift+Enter for new line)"
        autoSize={{ minRows: 1, maxRows: 5 }}
        disabled={disabled || isStreaming}
        className="ai-chat-textarea"
      />
      <div className="ai-chat-input-actions">
        {isStreaming ? (
          <Button
            type="default"
            danger
            icon={<StopOutlined />}
            onClick={onStop}
            className="ai-chat-stop-btn"
          >
            Stop
          </Button>
        ) : (
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={onSend}
            disabled={disabled || !value.trim()}
            className="ai-chat-send-btn"
          >
            Send
          </Button>
        )}
      </div>
    </div>
  );
};

export default InputArea;
